import { Bell, BellRing } from "lucide-react";
import { toast } from "sonner";
import { reminderKey, useShowReminders } from "@/lib/reminders";
import { errorMessage } from "@/lib/api";

export function RemindBell({ item, show, city, tid, compact = false }) {
  const { keys, toggle } = useShowReminders();
  if (!show?.date || show.date < new Date().toLocaleDateString("en-CA")) return null;
  const on = keys.has(reminderKey(item, show));
  const click = async (e) => {
    e.stopPropagation();
    try { toast.success((await toggle(item, show, city)) ? "We'll remind you the day before" : "Reminder removed"); }
    catch (err) { toast.error(errorMessage(err)); }
  };
  const Icon = on ? BellRing : Bell;
  return (
    <button type="button" data-testid={tid} onClick={click} aria-pressed={on} aria-label={on ? "Remove reminder" : "Remind me"}
      className={`shrink-0 flex items-center gap-1 rounded-full border text-xs font-semibold transition-colors ${compact ? "px-2 py-1" : "px-2.5 py-1.5"} ${on ? "bg-[#FFB800] border-[#FFB800] text-[#0B0F19]" : "border-[#26334D] text-slate-300 hover:text-white hover:border-slate-400"}`}>
      <Icon className="h-3.5 w-3.5" /> {on ? "Reminder on" : "Remind me"}
    </button>
  );
}
